export const bookmarkedCheckbox = [
  {
    value: "bookmarked",
    key: "Bookmarked Modules",
  },
];
